import { CHANGE_LANG } from './actionTypes';

export const changeLanguage = (lang) => ({
  type: CHANGE_LANG,
  lang,
});

